/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Export_ExcelInputs */

const vi_report_export_excel = /** @type {(inputs: Report_Export_ExcelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất Excel`)
};

/**

* @param {Report_Export_ExcelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_export_excel = /** @type {((inputs?: Report_Export_ExcelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Export_ExcelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_export_excel(inputs)
});